export default __webpack_public_path__ + "22405c819b3dd05438f61fb6427b1c98.png";